/* Back in stock (USA-thema, Horizon). Zelfde gedrag als het NL-blok, met store "us" in de POST.
   - Welke maat de klant aankijkt komt uit Horizon's eigen event shopify:product:select: de belofte daarvan
     levert de nieuwe variant (detail.resource met id, title, available). De bundelkiezer stuurt de verborgen
     Horizon-kiezer mee (mv-bundels.js, volgThema), dus ook een keuze daar komt hier binnen. Zo springt de
     knop op "Sold out" en verschijnt dit blok, net als in NL met Kaching.
   - Het blok staat in buy-buttons en wordt door Horizon niet opnieuw gerenderd bij een maatwissel; daarom
     zelf tonen en verbergen. */
import { StandardEvents } from '@shopify/events';

(() => {
  if (customElements.get('mv-back-in-stock')) return;

  const EMAIL = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  const UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  class MvBackInStock extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gekoppeld) return;
      this.dataset.gekoppeld = '1';
      this.veld = this.querySelector('.mv-bis__veld');
      this.pot = this.querySelector('.mv-bis__pot');
      this.knop = this.querySelector('[data-bis-verstuur]');
      this.uitkomst = this.querySelector('[data-bis-uitkomst]');
      if (!this.veld || !this.knop) return;

      this.knop.addEventListener('click', () => this.verstuur());
      this.veld.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); this.verstuur(); }
      });

      this.opKeuze = (e) => this.volg(e);
      this.sectie = this.closest('.shopify-section') || document;
      this.sectie.addEventListener(StandardEvents.productSelect, this.opKeuze);
    }

    disconnectedCallback() {
      this.sectie?.removeEventListener(StandardEvents.productSelect, this.opKeuze);
      delete this.dataset.gekoppeld;
    }

    async volg(e) {
      if (e.target?.closest?.('product-card')) return; // keuzes in productkaarten elders op de pagina
      try {
        const { detail } = await e.promise;
        const v = detail?.resource;
        if (v) this.zetVariant(v.id, v.title, v.available);
      } catch (fout) {
        if (fout?.name !== 'AbortError') console.warn('[mv-back-in-stock]', fout);
      }
    }

    tekst(sleutel) { return this.dataset[sleutel] || ''; }

    zetVariant(id, titel, beschikbaar) {
      if (beschikbaar) { this.hidden = true; return; }
      const nieuwe = String(id);
      if (this.getAttribute('variant-id') !== nieuwe) {
        // andere maat: een eerdere bevestiging slaat niet op deze maat, dus het formulier komt terug
        delete this.dataset.klaar;
        if (this.uitkomst) this.uitkomst.hidden = true;
        this.knop.disabled = false;
        this.knop.textContent = this.tekst('tekstKnop');
      }
      this.setAttribute('variant-id', nieuwe);
      if (titel && titel !== 'Default Title') {
        this.setAttribute('variant-title', titel);
        const sterk = this.querySelector('.mv-bis__intro strong');
        if (sterk) sterk.textContent = titel;
      }
      this.hidden = false;
    }

    toon(bericht, soort) {
      if (!this.uitkomst) return;
      this.uitkomst.textContent = bericht;
      this.uitkomst.dataset.soort = soort;
      this.uitkomst.hidden = false;
    }

    utm() {
      const uit = {};
      try {
        const p = new URLSearchParams(window.location.search);
        UTM.forEach((k) => { const v = p.get(k); if (v) uit[k] = v.slice(0, 120); });
      } catch (e) { /* geen utm's is geen fout */ }
      return uit;
    }

    async verstuur() {
      const email = (this.veld.value || '').trim();
      if (!EMAIL.test(email)) {
        this.veld.setAttribute('aria-invalid', 'true');
        this.veld.focus();
        this.toon(this.tekst('tekstFoutEmail'), 'fout');
        return;
      }
      this.veld.removeAttribute('aria-invalid');

      const origineel = this.knop.textContent;
      this.knop.disabled = true;
      this.knop.textContent = this.tekst('tekstBezig');
      const terug = (bericht) => {
        this.knop.disabled = false;
        this.knop.textContent = origineel;
        this.toon(bericht, 'fout');
      };

      try {
        const res = await fetch(this.getAttribute('endpoint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            variant_id: this.getAttribute('variant-id'),
            store: 'us',
            bron: 'pdp',
            bedrijf: this.pot ? this.pot.value : '',
            utm: this.utm(),
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) { terug(data.error || this.tekst('tekstFout')); return; }

        const maat = this.getAttribute('variant-title') || this.tekst('tekstDezeMaat');
        this.dataset.klaar = '1';
        const sjabloon = data.al_leverbaar ? this.tekst('tekstAlLeverbaar') : this.tekst('tekstGelukt');
        this.toon(sjabloon.replace('[size]', maat), 'goed');
      } catch (e) {
        terug(this.tekst('tekstFout'));
      }
    }
  }

  customElements.define('mv-back-in-stock', MvBackInStock);
})();
